import { questionnaireGql } from '../../../../data/gql-gen/questionnaire'

export const WAVE_KPI_CHANGES = questionnaireGql(/* GraphQL */ `
  query WaveKpiChanges($projectId: ID!, $waveId: ID!) {
    kpiChangesV2(projectId: $projectId, waveId: $waveId) {
      wave {
        waveId
        number
        label
      }
      previousWave {
        waveId
        number
        label
      }
      requiresAcknowledgement
      counts {
        subjects
        changes
        needsAcknowledgement
        information
      }
      subjects {
        trackingId
        questionNumber
        label
        status
        needsAcknowledgement
        changes {
          field
          code
          language
          market {
            surveyId
            country
          }
          target
          targetTrackingId
          kpiId
          targetLabel
          before
          after
          needsAcknowledgement
          description
        }
      }
    }
  }
`)
